module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIoAAAAmCAYAAAAbWQPxAAAAAXNSR0IArs4c6QAAAU5JREFUeF7t3DFKA2EUReHzUAQbK2t3IMQ1uAIRwX24DrdiYW3nBswGrOzFzu6FcRIIanGJ4jhw/iqQO/zhzFenuOtmOMUZF/X08dljgU8FSiiaSAoIJankBqGIICoglCiTI6FoICoglCiTI6FoICoglCiTI6FoICoglCiTI6FoICoglCiTI6FoICoglCiTI6FoICoglCiTI6FoICoglCiTI6FoICoglCiTI6FoICoglCiTI6FoICoglCiTI6FoICoglCiTI6FoICoglCiTI6FoICoglCiTI6FoICrwBUp3nwBXm6er6ra7j4E94L2q3obvuvtm64Z74AU4im519KcFlrC/gOufXPodlHPgYQtKdfcpcAC8VtXzGsr4BzzjuQQegQGZ558VWMLhYnw/Ox+h7JxuPg8KZT7vatJfKpRJ88/ncqHM511N+kt/A8oKvnz3ie++rG0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/ti_shi_title_bg.png
// module id = EfsU
// module chunks = 2